import styled from "@emotion/styled";
import CodeBlock from "@ext/markdown/elements/codeBlockLowlight/render/component/CodeBlock";
import type { Property } from "csstype";

const SmallFence = (props: { value: string; fixWidth?: boolean; overflow?: Property.Overflow; className?: string }) => {
	const { className, value, overflow } = props;
	return (
		<div className={className}>
			<CodeBlock style={{ overflow }} withoutHighlight>
				{value}
			</CodeBlock>
		</div>
	);
};

export default styled(SmallFence)`
	${(p) => (p.fixWidth ? "flex: 1; overflow: hidden;" : "")}

	> pre {
		padding: 2px 6px !important;
		margin: 0 !important;
		color: var(--color-fence-text);
	}
`;
